import store from '@/stores/store';
import Role from "@/utils/const/role";

export default (to, from, next) => {

    if (store.getters["authStore/selectedRole"]?.role_id != Role.MASTER_BUSINESS_OWNER) {
        next({ name: 'not-found' })
    }

}